import type { PointerHelp } from '@belong/ai-pointer';

export const REQUEST_A_PRO_HELP: PointerHelp = {
  title: 'Request a repair here',
  summary:
    'No tasks yet. Tap **Request A Pro** to ask for a repair, an upgrade, or any home service.',
};

export const FIRST_PAYOUT_HELP: PointerHelp = {
  title: 'When do I get paid?',
  summary:
    'Once we place residents in your home, you get paid on **the first of each month**, guaranteed.',
};

export const PAYOUT_ACCOUNT_HELP: PointerHelp = {
  title: 'Add an account to get paid',
  summary:
    'Without a **payout account**, we cannot send your earnings. Add yours here. Changing banks? Update the account and we may ask you to verify it.',
};

export const RESCHEDULE_INSPECTION_HELP: PointerHelp = {
  title: 'Need a different time?',
  summary:
    'You can reschedule your inspection right here. Tap **Reschedule** and pick a new slot, **up to 24 hours before** it starts.',
};
